/**
 * CUÁNTO ESTÁ TRADUCIDO CADA IDIOMA — generado, no se edita a mano.
 *
 *     python herramientas/cobertura_idiomas.py escribir
 *
 * 🔴 POR QUÉ EXISTE. El selector ofrecía 25 idiomas y el sitio estaba en
 * español a dos tercios: los archivos tenían todas las claves, pero con el
 * texto español copiado dentro. Quien entraba en inglés leía «Apoyar a la
 * Fundación». Eso incumple la regla de que todo lo publicado sea verdad.
 *
 * Ahora el sitio ofrece SOLO los idiomas que pasan del 90 %. En cuanto la
 * tabla de textos se complete y se importe, vuelven a aparecer solos.
 *
 * ⚠️ Que un idioma no se ofrezca NO borra su archivo ni su trabajo: sigue ahí,
 * esperando. Y si alguien llega con ese idioma en el navegador, el sitio cae en
 * el idioma por defecto de su dominio, que es lo que ya hacía.
 */

/** Porcentaje de las 203 claves realmente traducido, por idioma. */
export const COBERTURA = {
  'am':   96,
  'ar':   96,
  'bg':   96,
  'bn':   96,
  'bs':   95,
  'ca':   91,
  'cs':   95,
  'da':   95,
  'de':   95,
  'el':   96,
  'en':   98,
  'es':   100,
  'et':   95,
  'fa':   96,
  'fi':   95,
  'fil':  94,
  'fr':   95,
  'ga':   95,
  'gu':   96,
  'ha':   95,
  'he':   96,
  'hi':   96,
  'hr':   95,
  'hu':   95,
  'id':   95,
  'it':   94,
  'ja':   96,
  'ko':   96,
  'lt':   96,
  'lv':   96,
  'mk':   96,
  'mr':   96,
  'mt':   95,
  'nb':   94,
  'nl':   95,
  'pa':   96,
  'pl':   95,
  'pt':   89,
  'ro':   94,
  'ru':   96,
  'sk':   95,
  'sl':   95,
  'sq':   94,
  'sr':   96,
  'sv':   95,
  'sw':   95,
  'ta':   96,
  'te':   96,
  'th':   96,
  'tr':   96,
  'uk':   96,
  'ur':   96,
  'vi':   95,
  'yo':   96,
  'yue':  96,
  'zh':   96,
};

/** El mínimo para que un idioma se ofrezca en el selector. */
export const UMBRAL_IDIOMA = 90;

/** Los que hoy lo pasan. */
export const IDIOMAS_LISTOS = ['am', 'ar', 'bg', 'bn', 'bs', 'ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fa', 'fi', 'fil', 'fr', 'ga', 'gu', 'ha', 'he', 'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'mk', 'mr', 'nb', 'nl', 'pa', 'pl', 'ro', 'ru', 'sk', 'sl', 'sq', 'sr', 'sv', 'sw', 'ta', 'te', 'th', 'tr', 'uk', 'ur', 'vi', 'yo', 'yue', 'zh'];

/** Claves iguales al español que la tabla da por TRADUCIDAS (cognados),
 *  por idioma: la prueba del sitio las suma para cuadrar la cobertura. */
export const COGNADOS = {

};
